var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepotDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 16.5,
    stroke: "#00893F",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170:138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4998 20.5938C12.3617 20.5938 11.4359 21.5195 11.4359 22.6574C11.4359 23.7952 12.3617 24.721 13.4998 24.721C14.6377 24.721 15.5636 23.7952 15.5636 22.6574C15.5634 21.5195 14.6377 20.5938 13.4998 20.5938ZM13.4998 23.4901C13.0405 23.4901 12.6668 23.1166 12.6668 22.6574C12.6668 22.1982 13.0405 21.8246 13.4998 21.8246C13.9589 21.8246 14.3326 22.1981 14.3326 22.6574C14.3326 23.1165 13.9589 23.4901 13.4998 23.4901Z",
    fill: "#00683A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0498 20.5938C23.9119 20.5938 22.9861 21.5195 22.9861 22.6574C22.9861 23.7952 23.9118 24.721 25.0498 24.721C26.1877 24.721 27.1136 23.7952 27.1136 22.6574C27.1138 21.5195 26.1879 20.5938 25.0498 20.5938ZM25.0498 23.4901C24.5907 23.4901 24.2171 23.1166 24.2171 22.6574C24.2171 22.1982 24.5905 21.8246 25.0498 21.8246C25.5091 21.8246 25.8826 22.1981 25.8826 22.6574C25.8828 23.1165 25.5091 23.4901 25.0498 23.4901Z",
    fill: "#00683A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1987 13.2734H11.4983C10.3106 13.2734 9.34415 14.2397 9.34415 15.4274V22.5782C9.34415 22.9181 9.61975 23.1936 9.95964 23.1936C10.2995 23.1936 10.5751 22.9181 10.5751 22.5782V15.4274C10.5751 14.9185 10.9892 14.5043 11.4983 14.5043H20.1988C20.7079 14.5043 21.122 14.9185 21.122 15.4274V21.0396C21.122 21.5485 20.7079 21.9627 20.1988 21.9627H16.6159C16.276 21.9627 16.0004 22.2382 16.0004 22.5781C16.0004 22.918 16.276 23.1934 16.6159 23.1934H20.1987C21.3864 23.1934 22.3528 22.2271 22.3528 21.0394V15.4274C22.3528 14.2397 21.3865 13.2734 20.1987 13.2734Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9379 19.5729L27.4898 16.596C27.3868 16.3844 27.1719 16.25 26.9364 16.25H23.6377C23.2978 16.25 23.0222 16.5254 23.0222 16.8653C23.0222 17.2052 23.2978 17.4807 23.6377 17.4807H26.5515L27.7692 19.9839V22.5777C27.7692 22.9176 28.0448 23.1931 28.3847 23.1931C28.7246 23.1931 29.0002 22.9176 29.0002 22.5777V19.8422C29 19.7491 28.9787 19.6568 28.9379 19.5729Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87215 19.3125H5.30766C5.1378 19.3125 5 19.4505 5 19.6203C5 19.7902 5.1378 19.9282 5.30766 19.9282H7.87215C8.04219 19.9282 8.17982 19.7902 8.17982 19.6203C8.17982 19.4505 8.04202 19.3125 7.87215 19.3125Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87215 20.8789H6.48732C6.31729 20.8789 6.17966 21.0169 6.17966 21.1867C6.17966 21.3566 6.31746 21.4946 6.48732 21.4946H7.87215C8.04218 21.4946 8.17981 21.3566 8.17981 21.1867C8.17981 21.0169 8.04201 20.8789 7.87215 20.8789Z",
    fill: "#FFC20E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5391 20.0312C19.7092 20.0312 19.8468 19.8933 19.8468 19.7234V16.8768C19.8468 15.9579 19.3551 15.4922 18.3852 15.4922H15.0009C14.8309 15.4922 14.6933 15.63 14.6933 15.8C14.6933 15.9699 14.8311 16.1079 15.0009 16.1079H18.3852C19.093 16.1079 19.2315 16.3898 19.2315 16.877V19.7236C19.2315 19.8933 19.3693 20.0312 19.5391 20.0312Z",
    fill: "#00683A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170:138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(5 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepotDelivery);
export default __webpack_public_path__ + "static/media/depot-delivery.7fa2494e.svg";
export { ForwardRef as ReactComponent };